import '@/plugins';
import '@/directives';

import Vue from 'vue';
import VueGtag from 'vue-gtag';
import App from './App.vue';
// import './registerServiceWorker'
import router from './router';
import store from './store';

Vue.config.productionTip = false;

const gtag_id = process.env.VUE_APP_GTAG_ID;

if (gtag_id) {
  Vue.use(
    VueGtag,
    {
      config: { id: gtag_id },
    },
    router
  );
}

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
